PJQ.ajax = {};

PJQ.ajax.Request = class {
	constructor(options = {}) {
		this.setOptions(options);
	}

	setOptions(options = {}) {
		this.options = _.defaults(options, {
			method: 'GET',
			dataType: 'json',
			contentType: 'application/json',
			service: PJQ.constants.services.API,
			beforeSend: _.bind(function (xhr) {
				PJQ.helpers.apiHelpers.addHeaders(xhr, this.getService(), options.headers);
			}, this),
			isPascal: false,
			isApi2: false,
			isAPIv2: false,
			isOrigin: false,
			canAuthRetry: true
		});
	}

	getService() {
		let service;
		if (this.options.isOrigin) {
			service = PJQ.constants.services.ORIGIN;
		}
		else if (this.options.isAPIv2) {
			service = PJQ.constants.services.APIv2
		}
		else {
			service = this.options.service;
		}
		return service;
	}

	exec(method) {
		if (method)
			this.options.method = method.toUpperCase();

		let service = this.getService();
		if (this.options.endpoint) {
			this.options.url = PJQ.helpers.urlHelpers.buildApiUrl(this.options.endpoint, {
				isPascal: this.options.isPascal,
				service: service
			});
		}

		if((this.options.method === "PUT" || this.options.method === "POST" || this.options.method === "PATCH") && this.options.data == null) {
			this.options.data = {};
		}

		if (this.options.data)
			this.options.data = JSON.stringify(this.options.data);

		let result = {
			_success: null,
			success: function (callback) {
				this._success = callback;
				return this;
			},
			_done: null,
			done: function (callback) {
				this._done = callback;
				return this;
			},
			_fail: null,
			fail: function (callback) {
				this._fail = callback;
				return this;
			}
		}
		$.ajax(this.options).done(function () {
			if (typeof result._done === 'function') {
				result._done(...arguments);
			} else if (typeof result._success === 'function') {
				result._success(...arguments);
			}
		}).fail(_.bind(function (xhr) {
			if (service === PJQ.constants.services.APIv2 && xhr.status === 401 && this.options.canAuthRetry) {
				// we had a 401 error on the new api
				// we should try to get a refresh token if we haven't already tried
				PJQ.app.TokenManager.refreshAccessToken(_.bind(function (token) {
					// retry after refreshing the token
					if (_.size(token) > 0) {
						$.ajax(this.options).done(function () {
							if (typeof result._done === 'function') {
								result._done(...arguments);
							}
						}).fail(_.bind(function (xhr) {
							if (typeof result._fail === 'function') {
								result._fail(...arguments);
							}
						}, this));
					}
					else if (typeof result._fail === 'function') {
						result._fail(...arguments);
					}
				}, this));
			}
			else if (typeof result._fail === 'function') {
				result._fail(...arguments);
			}
		}, this));
		return result;
	}

	get() {
		return this.exec('get');
	}

	post() {
		return this.exec('post');
	}

	patch() {
		return this.exec('patch');
	}

	put() {
		return this.exec('put');
	}

	delete() {
		return this.exec('delete')
	}
};